<!--
    by:hansan
-->
<template>
    <div :class="'sidebar' + size" class="sidbar" >
<!--         //单侧边栏-->
        <div v-if="sidebarType==1" class="h-adaptive-w" @contextmenu="opennew">
            <div class="sidebar-item" v-for="item in chatList" :key="item.nm" >
                <router-link :to="item.url" :class="item.class"></router-link>
            </div>
        </div>
        <div v-if="sidebarType==2">
            <transition name="fade">
                <div class="h-adaptive xxdiv">
                    <div v-for="(item,index) in systemSetupList" :key="item.nm" class="sidebar-item">
                        <a class="sidebar-item" :class="itemIndex==index? 'sidebar-item-click':'sidebar-item-hover'"
                           :href="item.bt|realurl(navbardata.domainConfig,item.au)" target="_self" v-if="item.pc!='wx_im_setting'">
                            <i class="iconfont character" v-html="item.si"></i>
                            <span>{{item.nm}}</span>
                        </a>
                        <router-link  class="sidebar-item" :class="itemIndex==index? 'sidebar-item-click':'sidebar-item-hover'" to="/router=im/setting/wechat_account_manage" v-else>
                            <i class="iconfont character" v-html="item.si"></i>
                            <span>{{item.nm}}</span>
                        </router-link>
                    </div>
                </div>
            </transition>
            <div class="fiexd-sidebar" v-if="show">
                <div class="fiexd-sidebar-title">
                    IM管理
                </div>
                <div v-for="(v,i) in imSystemSetupList" :key="v.nm"
                     :style="{ color: imItemIndex==i?selected:original, }"
                     class="fiexd-sidebar-item"  @click="jump(v.au,i)">
                    {{v.nm}}
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import  Velocity from 'velocity-animate'
    import { mapGetters } from 'vuex'
    // 判断参数是否是其中之一
    function oneOf (value, validList) {
        for (let i = 0; i < validList.length; i++) {
            if (value === validList[i]) {
                return true;
            }
        }
        return false;
    }
    export default {
        name: "sidebar",
        props:{
            size: {
                validator (value) {
                    return oneOf(value, ['zero','small', 'default']);
                },
                default: 'default'
            },
            sidebarType:{

            },
        },
        data(){
            return{
                show: true,
                selected:'#0099ff',//im当前
                original:"#333",//im原始
                itemIndex:-1,
                imItemIndex:-1,
                systemSetupList:[],// 系统设置下的侧边栏
                imSystemSetupList:[],//im管理侧边栏
                chatList:[
                    {
                        nm:'会话窗口',
                        url:'/router=im/chat_page/chat',
                        class:'chatbar'
                    },
                    {
                        nm:'好友列表',
                        url:'/router=im/chat_page/friendslist',
                        class:'friendbar'
                    }
                ]
            }
        },
        filters:{
        },
        watch:{
            navbardata:function () {
                // console.log("这个值会改变吗")
                if(this.navbardata.authPrivileges){
                    this.getSystemSettingPermission();
                }
            }
        },
        computed:{
            ...mapGetters('im',{
                navbardata:'currentUser'
            })
        },
        methods:{
            opennew(){
                console.log('000')
                localStorage.setItem("nstore", JSON.stringify(this.$store.state));

            },
            //根据返回的路由跳转
            jump(au,i){
                console.log(au,i)
                this.imItemIndex=i;
                this.$router.push({path:`/${au.substring(4)}`,query:{t:Date.now()}})
            },
            //获取系统设置权限
            getSystemSettingPermission(){
                this.chatList =[
                    {
                        nm:'会话窗口',
                        url:'/router=im/chat_page/chat',
                        class:'chatbar'
                    },
                    {
                        nm:'好友列表',
                        url:'/router=im/chat_page/friendslist',
                        class:'friendbar'
                    }
                ]
			    const len = this.navbardata.authPrivileges.length
              console.log(len,'这特娘的咋没有呢')
                for (let i=0; i < len; i++){
                    if(this.navbardata.authPrivileges[i].nm=="系统设置"){
                        this.systemSetupList = this.navbardata.authPrivileges[i].list;
                        for (let j=0;j<this.navbardata.authPrivileges[i].list.length;j++){
                            if (this.navbardata.authPrivileges[i].list[j].nm=="IM管理"){
                                this.itemIndex=j;//定位系统设置列表位置
                                this.imSystemSetupList = this.navbardata.authPrivileges[i].list[j].list
							    console.log(this.imSystemSetupList ,'vvvvvvvvvvvvvvvvv')
                            }
                        }
                    }
                    if(this.navbardata.authPrivileges[i].nm=="IM"){
                        let imlist=this.navbardata.authPrivileges[i].list;
                        for (let jj=0;jj<imlist.length;jj++){
                            if (imlist[jj].pc=="wx_im_quality_inspection" && imlist[jj] !=null){
                                this.chatList.push({
                                    nm:'质检',
                                    url:'/router=im/inspection',
                                    class:'icon_check'
                                })
                            }
                            //朋友圈权限
                            if (imlist[jj].pc=="wx_im_friends_circle"){
                                this.chatList.push({
                                    nm:'朋友圈',
                                    url:'/router=im/chat_page/friendCircle',
                                    class:'friend_circle'
                                })
                            }
                            if (imlist[jj].pc=="wx_im_operations_management" && imlist[jj] !=null){
                                let klist = imlist[jj].list
                                let yy = false;
                                for(let k = 0;k<klist.length;k++){
                                    if(klist[k].pc == "wx_im_operation_send_friends_circle" || klist[k].pc == "wx_im_mass_texting_task" ){
                                        yy = true
                                    }
                                }
                                if(yy){
                                    this.chatList.push({
                                        nm:'运营',
                                        url:'/router=im/operation',
                                        class:'icon_operate'
                                    })
                                }
                            }
                            if (imlist[jj].pc=="wx_im_individual_mass_texting" && imlist[jj] !=null){
                                let klist = imlist[jj].list
                                let grqf = false;
                                for(let k = 0;k<klist.length;k++){
                                    if(klist[k].pc == "wx_im_my_task" || klist[k].pc == "wx_im_my_mass_texting" ){
                                        grqf = true
                                    }
                                }
                                if(grqf){
                                    this.chatList.push({
                                        nm:'群发',
                                        url:'/router=im/individual',
                                        class:'person_send'
                                    })
                                }
                            }
                            //清粉权限
                            if (imlist[jj].pc=="check_remove_powder"){
                                this.chatList.push({
                                    nm:'清粉',
                                    url:'/router=im/powder',
                                    class:'icon_powder'
                                })
                            }
                        }

                    }
                };
                let meteName=this.$route.meta.title||'微信号管理';
                for (let k=0;k<this.imSystemSetupList.length;k++){
                    // console.log(this.imSystemSetupList[k])
                    if(this.imSystemSetupList[k].nm==meteName){
                        // console.log("kzdl",k)
                        this.imItemIndex=k;
                    }
                }
            }
        },
      created() {
            //监听获取第一次权限，刷新获取缓存中的系统设置权限
            // console.log(JSON.parse(window.localStorage.getItem("userInfo")))
            if(this.navbardata.authPrivileges){
              console.log(this.navbardata,'this.navbardata')
                this.getSystemSettingPermission();
            }
        }
    }
</script>

<style scoped lang="less">
    .sidbar {
        color: #fff;
        font-size: 14px;
        /*     itsm   */
        .sidebar-item-hover:hover{ background:#33343B;}
        .sidebar-item{
            width: 100%;
            height: 40px;
            text-align: left;
            line-height: 40px;
            color: white;
        }
        .sidebar-item-click{
            background:#0099ff;
        }
        .h-adaptive{
            position: fixed;
            z-index: 1000;
            height: calc(100vh - 50px);
            width: 50px;
            background: #4a4c56;
        }
        .h-adaptive-w{
            height: calc(100vh - 50px);
            background: #1D232A;
            .sidebar-item{
                height: 60px;

                &:hover{
                    background: #000000;
                }
            }
            a{
                display: block;
                width: 100%;
                height: 60px;
            }
            .chatbar{
                background: url(../../../../static/img/icon_chat.png) center no-repeat;
            }
            .chatbar:hover,.chatbar.router-link-active{
                background: url(../../../../static/img/icon_chat_on.png) center no-repeat;
            }
            .friendbar{
                background: url(../../../../static/img/icon_friends.png) center no-repeat;
            }
            .friendbar:hover,.friendbar.router-link-active{
                background: url(../../../../static/img/icon_friends_on.png) center no-repeat;
            }
            .icon_check{
                background: url(../../../../static/img/icon_check.png) center no-repeat;
            }
            .icon_check:hover,.icon_check.router-link-active{
                background: url(../../../../static/img/icon_check_on.png) center no-repeat;
            }
            .icon_operate{
                background: url(../../../../static/img/icon_operate.png) center no-repeat;
            }
            .icon_operate:hover,.icon_operate.router-link-active{
                background: url(../../../../static/img/icon_operate_on.png) center no-repeat;
            }
            .friend_circle{
                background: url(../../../../static/img/icon_wechat.png) center no-repeat;
            }
            .friend_circle:hover,.friend_circle.router-link-active{
                background: url(../../../../static/img/icon_wechat_on.png) center no-repeat;
            }
            .person_send{
                background: url(../../../../static/img/icon_gsend.png) center no-repeat;
            }
            .person_send:hover,.person_send.router-link-active{
                background: url(../../../../static/img/icon_gsend_on.png) center no-repeat;
            }
            .icon_powder{
                background: url(../../../../static/img/icon_jcjs.png) center no-repeat;
                background-size: 28px 28px;
            }
            .icon_powder:hover,.icon_powder.router-link-active{
                background: url(../../../../static/img/icon_jcjs_on.png) center no-repeat;
                background-size: 28px 28px;
            }
        }
    }
    /*     small宽度   */
    .sidebarsmall{
        width: 50px;
        background: #4a4c56;
    }
    /*    默认宽度  */
    .sidebardefault{
        width: 190px;

    }
    .sidebardoubel{
        width: 190px;
    }
    /* 双侧边栏 定位   */
    .fiexd-sidebar{
        position: fixed;
        left: 50px;
        width: 140px;
        z-index: 1;
        color: #2A2A2A;
        text-align: center;
        .fiexd-sidebar-title{
            height: 60px;
            line-height: 60px;
            background: #f7f8f9;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-weight: bold;
            font-size: 16px;
        }
        .fiexd-sidebar-item{
			cursor: pointer;
            height: 40px;
            line-height: 40px;
            color: #333;
            text-align: left;
            padding-left: 28px;
        }
        .fiexd-sidebar-item:hover{
            color: #0099ff
        }
    }


/*    dh*/
    .xxdiv
    {
        width:50px;
        overflow: hidden;
        white-space: nowrap;
        background: #4a4c56;
        transition:width .5s;
        -moz-transition:width .5s; /* Firefox 4 */
        -webkit-transition:width .5s; /* Safari and Chrome */
        -o-transition:width .5s; /* Opera */
    }

    .xxdiv:hover
    {
        width:190px;
    }
    /*字体颜色*/
    .fbb{
        color:#0099ff !important;
    }
    .character{
        display: inline-block;
        width: 50px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar.vue